export default __webpack_public_path__ + "static/media/gallery_06.4e95419b.jpg";